import { useFeatures } from './useFeatures'

const { convertDateTimeForDisplay } = useTimeZone()

const { features } = useFeatures()

const WAITLIST_DISABLED_VALUE = -1

// TODO: move to event domain later e.g '@/platform/domain/event
function hasWaitlistMaxOverride(event) {
  return features.event_waitlist_overrides && event.waitlist_max_override !== WAITLIST_DISABLED_VALUE
}

function getEventItem({ event, attendance, venue, offeringType }) {
  const eventItem = {
    // default entries from events
    ...event,
    attendingText: +event.max_occupancy ? `${event.attending_count}/${event.occupancy}` : `${event.attending_count}`,
    starts_at: convertDateTimeForDisplay(event.starts_at),
    ends_at: convertDateTimeForDisplay(event.ends_at),
    // spread entries from venues
    venue,
    is_online: venue?.is_online,

    // spread entries from offering types
    base_color: `#${
      offeringType?.background_color
    }0d`,
    ring_color: `#${
      offeringType?.background_color
    }`,
    // offeringType.waitlist_max === null means unlimited, 0 means disabled
    waitlist_max: hasWaitlistMaxOverride(event) ? event?.waitlist_max_override : offeringType?.waitlist_max,
    is_course:
      offeringType?.schedule_type === 'course',
    category: event?.category?.name || offeringType?.category?.name,
    type: offeringType?.schedule_type,
    // custom entries
    isEnded:
      Date.now() >= new Date(event.ends_at).getTime(),
    is_full:
      event.max_occupancy && event.attending_count >= event.max_occupancy,

    registrationsNotOpen: event.active_registration_status?.restriction_codes.includes('registrations_not_open'),
    registrationsClosed: event.active_registration_status?.restriction_codes.includes('registrations_closed'),

    // custom entries from attendances
    customer_on_waitlist: attendance?.waitlist_spot?.status === 'on_waitlist',
    customer_spot_reserved: attendance?.waitlist_spot?.status === 'spot_reserved',
    customer_attending: attendance?.status === 'registered',
    waitlist_position: attendance?.waitlist_spot?.position,
    waitlist_disabled: hasWaitlistMaxOverride(event) ? event?.waitlist_max_override === 0 : offeringType?.waitlist_max === 0,
    ...(event.offering_type && {
      offering_type: offeringType,
    }),
  }

  return eventItem
}

export function useGetEventItem() {
  return getEventItem
}
